import { render, staticRenderFns } from "./checkout-footer.vue?vue&type=template&id=df1e12a2&"
import script from "./checkout-footer.vue?vue&type=script&lang=js&"
export * from "./checkout-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports